import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeferredMessageFormatCompiler } from './deferred-message-format-compiler';

@Injectable({ providedIn: 'root' })
export class MessageFormatLoaderService {
    private compilerLoaded = false;

    constructor(
        private deferredCompiler: DeferredMessageFormatCompiler,
        private translateService: TranslateService
    ) {}

    /**
     * Lazily load MessageFormat compiler.
     * Returns a promise that resolves when compiler is fully loaded and ready.
     */
    async loadMessageFormatCompiler(): Promise<void> {
        if (this.compilerLoaded) {
            return;
        }

        try {
            const { TranslateMessageFormatCompiler } = await import('ngx-translate-messageformat-compiler');

            const realCompiler = new TranslateMessageFormatCompiler();

            // Set it on the deferred compiler
            this.deferredCompiler.setRealCompiler(realCompiler, this.translateService);

            this.compilerLoaded = true;
        } catch (error) {
            console.error('❌ Failed to load MessageFormat compiler:', error);
            throw error;
        }
    }
}
